const heroes = {
    support: [
      {name: 'Ana', shortId: 'ZcCGKrYgr0k', path: 'ana'}, {name: 'Baptiste', shortId: 'uxdy2SMf9CE', path: 'baptiste'},
      {name: 'Brigitte', shortId: 'brigitte', path: 'msFq8_IRebI'}, {name: 'Lúcio', shortId: 'lucio', path: 'ywTNgR3ldFc'},
      {name: 'Mercy', shortId: 'YM5UAqBC6aY'}, {name: 'Moira', shortId: '8tLopqeL9s8', path: 'moira'},
      {name: 'Zenyatta', shortId: 'SBXpKdmJBLU', path: 'zenyatta'}
      ],
    tank: [
      {name: 'D.va', shortId: 'jN3TISLTVyc', path: 'dva'}, {name: 'Orisa', shortId: 'KNBmyM6Ievc', path: 'orisa'},
      {name: 'Reinhardt', shortId: 'zLFbm6YckoU', path: 'reinhardt'}, {name: 'Roadhog', shortId: '5URzijwRPfk', path: 'roadhog'},
      {name: 'Sigma', shortId: 'nWEpjzgMqyU', path: 'sigma'}, {name: 'Winston', shortId: 'JNJ42WCOxV0', path: 'winston'},
      {name: 'Wrecking Ball', shortId: '-kA-g_SX9vA', path: 'wrecking-ball'}, {name: 'Zarya', shortId: 'gTcKbsKDkWk', path: 'zarya'}
      ],
    damage: [
      {name: 'Ashe', shortId: 'G8LbOecWGug', path: 'ashe'}, {name: 'Bastion', shortId: 'L4D1C7JU7ts', path: 'bastion'},
      {name: 'Doomfist', shortId: 'o79pqCH3QMQ', path: 'doomfist'}, {name: 'Genji', shortId: 'lYOjIDhJIG0', path: 'genji'},
      {name: 'Hanzo', shortId: 'oJ09xdxzIJQ', path: 'hanzo'}, {name: 'Junkrat', shortId: 'mFGQG8I68h8', path: 'junkrat'},
      {name: 'McCree', shortId: 'kq4OlEDiCi8', path: 'mccree'}, {name: 'Mei', shortId: 'J4hB88uMY8k', path: 'mei'},
      {name: 'Pharah', shortId: 'ks-mLJS0pe8', path: 'pharah'}, {name: 'Reaper', shortId: 'uK4WSF0rCcM', path: 'reaper'},
      {name: 'Soldier: 76', shortId: 'V_0eqEbG7yA', path: 'soldier-76'}, {name: 'Sombra', shortId: 'bcrPuSRYA4U', path: 'sombra'},
      {name: 'Symmetra', shortId: 'Eko_DhY8oTo', path: 'symmetra'}, {name: 'Torbjörn', shortId: 's7AO0bcK6Qg', path: 'torbjorn'},
      {name: 'Tracer', shortId: '_SvYmsNCWsw', path: 'tracer'}, {name: 'Widowmaker', shortId: 'fvPp6XbbTb0', path: 'widowmaker'}
      ]
  }

export default heroes

// start server with `npm start`